// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".verify-container {\n  text-align: center;\n  margin-top: 20%;\n  font-size: 2em;\n}\n.verify-card {\n  background-color: #50596c !important;\n}", ""]);
// Exports
module.exports = exports;
